import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as engagementCharterComponents from '../../engagement-charter-components'

export const RESOURCE = {
  payload: {
    description:
      'One source document belonging to a project, used to generate its engagement charter.',
    dimension: engagementCharterComponents.RESOURCE.payload,
    level: 0,
    name: 'Engagement Charter Component',
    partialId: PartialId.Standard.create('engagement_charter_comp'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
